import { createRouter, createWebHistory } from 'vue-router'

// Vuex
import store from '@/store';

// Import all Modules
import { authRoutes } from '@/modules/auth';
import { clientRoutes } from '@/modules/clients';
import { companiesRoutes } from '@/modules/companies';
import { usersRoutes } from '@/modules/users';
import { campaignRoutes } from '@/modules/campaign';
import { openersRoutes } from '@/modules/openers';
import { closersRoutes } from '@/modules/closers';
import { adminRoutes } from '@/modules/admin';
import { installsRoutes } from '@/modules/installs';
import { inventoryRoutes } from '@/modules/inventory';
import { accountingRoutes } from '@/modules/accounting';
import { hrRoutes } from '@/modules/hr';
import { taliupRoutes } from '@/modules/taliup';
import { statusRoutes } from '@/modules/status';
import { terminalRoutes } from '@/modules/terminals';
import { reviewsRoutes } from '@/modules/reviews';
import { roleRoutes } from '@/modules/roles';
import { docuSignRoutes } from '@/modules/docusign';
import { csRoutes } from '@/modules/customer_service';
import { transactionRoutes } from '@/modules/transactions';
import { orderTrackingRoutes } from '@/modules/order_tracking';
import { reportsRoutes } from '@/modules/reports';
import { duplicatesRoutes } from '@/modules/duplicates';
import { leadGroupRoutes } from '@/modules/lead_groups';
import { midBuyerRoutes } from '@/modules/mid_buyers';
import { leadRoutes } from '@/modules/leads';
import { reassignRoutes } from '@/modules/reassign';
import { scoreboardRoutes } from '@/modules/scoreboard';
import { notificationRoutes } from '@/modules/notifications';
import { blogsRoutes } from '@/modules/blogs';
import { settingsRoutes } from '@/modules/settings';
import { processorRoutes } from '@/modules/processors';
import { documentCentreRoutes } from '@/modules/document_centre';
import { cashAdvanceRoutes } from '@/modules/cash_advance';
import { timeTrackerRoutes } from '@/modules/time_tracker';

// Combine all the imported routes together
const routes = [
    ...authRoutes,
    ...clientRoutes,
    ...companiesRoutes,
    ...usersRoutes,
    ...campaignRoutes,
    ...statusRoutes,
    ...terminalRoutes,
    ...reviewsRoutes,
    ...roleRoutes,
    ...docuSignRoutes,
    ...openersRoutes,
    ...closersRoutes,
    ...adminRoutes,
    ...installsRoutes,
    ...inventoryRoutes,
    ...accountingRoutes,
    ...hrRoutes,
    ...taliupRoutes,
    ...csRoutes,
    ...transactionRoutes,
    ...orderTrackingRoutes,
    ...reportsRoutes,
    ...duplicatesRoutes,
    ...leadGroupRoutes,
    ...midBuyerRoutes,
    ...leadRoutes,
    ...reassignRoutes,
    ...scoreboardRoutes,
    ...notificationRoutes,
    ...blogsRoutes,
    ...settingsRoutes,
    ...processorRoutes,
    ...documentCentreRoutes,
    ...cashAdvanceRoutes,
    ...timeTrackerRoutes,
];

const router = createRouter({
    history: createWebHistory(),  // ← replaces mode: 'history'
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ top: 0 }),  // ← y:0 changed to top:0 in Vue Router 4
    routes
})

// Do before each route
router.beforeEach((to, from, next) => {
    if (!to.meta.requiresAuth) {
        next();
    } else {
        try {
            if (!store.getters.getAuthStatus) {
                store.dispatch('unAuthenticateUser');
                router.push('/login');
            }
            next();
        } catch (error) {
            console.log('-------error', error);
            router.push('/login');
        }
    }
})

router.onError((error) => {
    if (error.message?.includes('Failed to fetch dynamically imported module') ||
        error.message?.includes('Failed to load module script')) {
        window.location.reload()
    }
})

router.afterEach((to, from) => {
    // store.dispatch('hideLoader');
})

export default router;